// GoogleTag.tsx
import { useEffect } from 'react';
import { env } from '../../env';

export function GoogleTagScript(): React.JSX.Element | null {
  useEffect(() => {
    const googleTagId = env.VITE_GOOGLE_TAG_ID;
    if (!googleTagId) {
      return;
    }

    if (document.getElementById('gtag-js')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'gtag-js';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${googleTagId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer!.push(arguments);
    };

    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
    });

    window.gtag('js', new Date());
    window.gtag('config', googleTagId);
  }, []);

  return null;
}
